import { ClientError } from '@ricoh/ria.client.core/errors';

import type { AIModelValueSet } from '~/common/model/api/ai-model';

import type { TextLayerSettings, TextLayerSettingsSubmitData } from './_document-type.type';

/**
 * Create TextLayer Settings.
 *
 * @param {AIModelValueSet[] | undefined} aiModelValueSet AI Model ValueSet.
 * @param {TextLayerSettingsSubmitData} submitData SubmitData.
 *
 * @returns {TextLayerSettings} TextLayer Settings.
 */
export function createTextLayerSettings(
  aiModelValueSet: AIModelValueSet[] | undefined,
  { textLayer, ocrModel }: TextLayerSettingsSubmitData,
): TextLayerSettings {
  if (!textLayer) {
    return {
      textLayer: false,
      ocrModel: undefined,
    };
  }

  const ocrAIModel = aiModelValueSet?.find((aiModel) => aiModel.aiModelKey === ocrModel);
  if (!ocrAIModel) {
    throw new ClientError({
      module: 'logic',
      message: 'Invalid OCR AI Model',
      cause: {
        ocrModel,
      },
    });
  }

  return {
    textLayer: true,
    ocrModel: ocrAIModel,
  };
}
